module.exports = __webpack_public_path__ + "static/media/Shock O Banana Cover Art.dfde3379.jpg";